import React, {Component} from 'react'
import ProductContainer from "./product-container";
import ItemFilter from "./item-filter";
import {getData} from "../util/DataProvider"
import {normalizeForSearch} from "../util/CommonUtils"

const ALL_INDICATOR = "ALL";

class Overview extends Component {
    state = {
        loaded: false,
        products: [],
        displayedProducts: [],
        categories: [],
        companies: [],
        displayedCompanies: [],
        filter: {
            searchText: null,
            company: ALL_INDICATOR,
            category: ALL_INDICATOR

        }
    };

    async getData() {
        await getData()
            .then(res => this.calculateStage(res));
    }


    async calculateStage(itemsAsJson) {
        let companies = itemsAsJson.map(item => item.Company);
        let uniqueCompanies = [...new Set(companies)].sort();
        uniqueCompanies.unshift(ALL_INDICATOR);

        let categories = itemsAsJson.map(item => item.Category);
        let uniqueCategories = [...new Set(categories)];
        uniqueCategories.unshift(ALL_INDICATOR);

        this.state = {
            loaded: true,
            products: itemsAsJson,
            displayedProducts: itemsAsJson,
            categories: uniqueCategories,
            companies: uniqueCompanies,
            displayedCompanies: uniqueCompanies,
            filter: {
                searchText: null,
                company: ALL_INDICATOR,
                category: ALL_INDICATOR

            }
        };

        await this.setState(this.state);
    }

    async componentDidMount() {
        if (this.state.loaded) {
            return;
        }
        await this.getData();
        const urlSearchString = window.location.search;

        const params = new URLSearchParams(urlSearchString);

        const searchTextParam = params.get('search');
        const categoryParam = params.get('category');
        const companyParam = params.get('company');

        if (categoryParam) {
            this.state.filter.category = categoryParam;
        }
        if (companyParam) {
            this.state.filter.company = companyParam;
        }
        if (searchTextParam) {
            this.state.filter.searchText = searchTextParam;
        }

        await this.filter();


    }

    filter = () => {
        let currentState = this.state;

        let displayedItems = this.getDisplayedItems(currentState.products, currentState.filter);
        currentState.displayedProducts = displayedItems;
        this.setState(currentState);
    }

    resetFilter = () => {
        let currentFilter = this.state.filter;
        currentFilter.searchText = null;
        currentFilter.company = ALL_INDICATOR;
        currentFilter.category = ALL_INDICATOR;
        this.state.displayedCompanies = this.state.companies;
        this.filter();
        //TODO nicht schön...
        document.getElementById("filter-search-text").value = null;
    }

    getDisplayedItems(items, filter) {
        let displayedItems;
        let searchText = filter.searchText;
        let company = filter.company;
        let category = filter.category;

        if (searchText || company !== ALL_INDICATOR || category !== ALL_INDICATOR) {
            displayedItems = items.filter(item => this.match(item, filter));
        } else {
            displayedItems = Array.from(items);
        }

        return displayedItems;
    }

    match(item, filter) {
        let searchText = filter.searchText;
        searchText = normalizeForSearch(searchText);
        let match = true;

        if (searchText) {
            let companyName = normalizeForSearch(item.Company);
            if (companyName && companyName.indexOf(searchText) >= 0) {
                match = true;
            } else {
                let itemName = normalizeForSearch(item.Name);
                match = itemName && (itemName.indexOf(searchText) >= 0)
            }
        }
        if (match) {
            let company = filter.company;
            if (company !== ALL_INDICATOR) {
                match = item.Company === company;
            }
        }

        if (match) {
            let category = filter.category;
            if (category !== ALL_INDICATOR) {
                match = item.Category === category;
            }
        }

        return match;


    }

    filter2 = (searchText) => {
        let currentState = this.state;
        currentState.displayedProducts = currentState.products.filter(item => item.Company.toLowerCase() === searchText.toLowerCase());
        this.setState(currentState);
    }

    categorySelected = (category) => {
        // Limit list of companies for this category
        let currentState = this.state;
        const matchingItems = this.getDisplayedItems(currentState.products, currentState.filter);
        const allMatchingCompanies = matchingItems.map(item => item.Company);
        let uniqueMatchingCompanies = [...new Set(allMatchingCompanies)].sort();
        uniqueMatchingCompanies.unshift(ALL_INDICATOR);
        this.state.displayedCompanies = uniqueMatchingCompanies;
        this.setState(currentState);

    }

    render() {

        return <React.Fragment>

            <div className="bicomm-header">
                <div className="bicomm-header-image">
                    <img src="./assets/images/logo_museum-662w.png" alt="Bicomm"/>
                </div>
            </div>

            <div className="item-filter">
                <ItemFilter
                    filter={this.state.filter}
                    categories={this.state.categories}
                    companies={this.state.displayedCompanies}
                    numberOfItems={this.state.displayedProducts.length}
                    onFilter={() => this.filter()}
                    onResetFilter={() => this.resetFilter()}
                    onSelectCategory={() => this.categorySelected(this.state.filter.category)}
                >
                </ItemFilter>
            </div>

            <div className="main-container">
                <div className="product-container">
                    <ProductContainer
                        displayedProducts={this.state.displayedProducts}
                        currentFilter={this.state.filter}
                    >
                    </ProductContainer>


                </div>

            </div>


        </React.Fragment>
    }
}

export default Overview;
